export const AddImageIcon = () => (
    <svg
        width={20}
        height={20}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="fill-irBlue-200 dark:fill-white group-hover:fill-white"
    >
        <path d="M7.981 7.747a2.294 2.294 0 1 0 0-4.588 2.294 2.294 0 0 0 0 4.588Zm0-3.16a.865.865 0 1 1 0 1.731.865.865 0 0 1 0-1.73Z" />
        <path d="m4.505 9.939 2.97 2.97a.714.714 0 0 0 1.01 0l5.499-5.498 2.445 2.445v2.287a.714.714 0 1 0 1.428 0V.714A.714.714 0 0 0 17.143 0H.714A.714.714 0 0 0 0 .714v16.429a.714.714 0 0 0 .714.714h11.429a.714.714 0 1 0 0-1.428H1.429v-3.413l3.076-3.077ZM1.43 1.429h15v6.407l-1.94-1.94a.714.714 0 0 0-1.01 0L7.98 11.394l-2.97-2.97a.714.714 0 0 0-1.01 0l-2.572 2.571V1.43ZM19.285 16.428h-1.428V15a.714.714 0 0 0-1.429 0v1.428h-1.429a.714.714 0 0 0 0 1.43h1.429v1.428a.714.714 0 1 0 1.429 0v-1.429h1.428a.714.714 0 0 0 0-1.428Z" />
    </svg>
);
